import React, { useEffect } from 'react'
import { useDataChange, useDataFormat, useDataValue } from 'Simple/Data'
import View from './view.js'

export default function Logic(props) {
  let tabId = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'id',
  })
  let syncThreadId = useDataFormat({
    viewPath: props.viewPath,
    context: 'global',
    path: 'tabs',
    format: value => value.find(item => item.id === tabId)?.sync?.threadId,
  })
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'tab',
  })

  useEffect(() => {
    if (!syncThreadId) return

    change(next => {
      next.sync.threadId = null
      next.selected.thread_id = syncThreadId
      next.selected.pinned_thread_id = syncThreadId
    })
  }, [syncThreadId]) // eslint-disable-line
  // ignore change

  return <View {...props} />
}
